<template>
  <Modal 
    ref="cancelRequestModalRef"
    @onNegativeActionClick="closeModal"
    @onPositiveActionClick="confirm"
    negativeActionText="Geri Dön"
    positiveActionText="Talepten Vazgeç"
    class="cancel-request-modal"
    type="warning"
    :showIcon="true"
    :modalStyle="{ width: '460px'}"
  >
    <template v-slot:body>
      <div class="cancel-request-modal-content">
        <p>Erken ödeme talebinden vazgeçmek <br>istediğinize emin misiniz?</p>
      </div>
    </template>
  </Modal>
</template>

<script>
import { ref } from 'vue';
import { Modal } from '@n11/so-ui-components';

export default {
  name: "CancelRequestModal",
  components: {
    Modal,
  },
  props: {
    requestNumber: {
      type: String,
      default: '',
    },
  },
  setup(props, { emit }) {
    const cancelRequestModalRef = ref(null);
    
    const openModal = () => {
      if (cancelRequestModalRef.value) {
        cancelRequestModalRef.value.openModal();
      }
    };
    
    const closeModal = () => {
      if (cancelRequestModalRef.value) {
        cancelRequestModalRef.value.hiddenModal();
      }
    };
    
    const confirm = () => {
      emit('confirm', props.requestNumber);
      closeModal();
    };
    
    return {
      cancelRequestModalRef,
      openModal,
      closeModal,
      confirm,
      requestNumber: props.requestNumber,
    };
  },
  emits: ['confirm'],
};
</script>

<style scoped lang="scss">
@import '@/assets/styles/variables.scss';

.cancel-request-modal-content {
  padding: 4px 0;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;

  p {
    font-size: 20px;
    font-weight: 700;
    line-height: 26px;
    letter-spacing: -0.2px;
    color: $colorN80;
    margin: 0;
    text-align: center;
  }
}
</style>

